import React, { useEffect } from 'react';
import styles from './Login.module.css'; // Import the CSS module

function Login() {
  return (
    <div className={styles.loginPage}>
      <div className={styles.loginContainer}>
        <h1 className={styles.loginHeader}>Login to PharmaPass</h1>
        <p className={styles.loginText}>Materiały dostępne w tym serwisie są przeznaczone dla środowiska lekarskiego.</p>
        <a className={styles.loginButton} href="https://interaktywneseminaria.pl/pharmapass/login">Zaloguj się</a>
        <p className={styles.loginFooter}>Nie posiadasz konta w Pharma Pass?</p>
      </div>
    </div>
  );
}

export default Login;